import React, { useEffect, useState } from 'react'
import BigModal from '../../../../components/Modals/BigModal'
import API from '../../../../services/API'
import {
  Alert,
  Button,
  Grid,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material'
import EPCRView from '../EPCRView/EPCRView'
import Header from '../EPCRView/Header'
import DemographicsModule from '../EPCRView/DemographicsModule'
import IncidentModule from '../EPCRView/IncidentModule'
import Safeguarding from '../EPCRView/Safeguarding'
import HSIncidentModule from '../EPCRView/HSIncidentModule'
import HxModule from '../EPCRView/HxModule'
import AssessModule from '../EPCRView/AssessModule'
import VitalsModule from '../EPCRView/VitalsModule'
import TreatmentModule from '../EPCRView/TreatmentModule'
import LiveTimelineModule from '../EPCRView/LiveTimelineModule'
import Plan from '../EPCRView/Plan'
import ClinicalAdviceLine from '../EPCRView/ClinicalAdviceLine'
import ShareCode from '../../ePCR/Sharing/ShareCode'

const RecentPopup = ({ open, onClose, epcrID }) => {
  const [record, setRecord] = useState({})
  const [loading, setLoading] = useState(true)
  const [calNotes, setCalNotes] = useState([])

  useEffect(() => {
    if (epcrID) {
      API.get('/my-recent-epcr-data/' + epcrID)
        .then((res) => {
          if (res.status === 200) {
            setRecord(res.data)
          }
        })
        .finally(() => setLoading(false))
    }
  }, [epcrID])

  return (
    <BigModal open={open} onClose={onClose}>
      {loading ? (
        <LinearProgress />
      ) : Object.keys(record).length > 0 ? (
        <Stack gap={2}>
          <Header record={record} />
          <Stack paddingX={1} alignItems="center">
            <Typography variant="caption" color="#c00000">
              The information contained herein is privileged and confidential
              and is protected by UK Data Protection laws, including the Data
              Protection Act 2018, and the Computer Misuse Act 1990.
            </Typography>
            <Typography variant="caption" color="#c00000">
              Any unauthorised access, disclosure, distribution, or use of this
              software is strictly prohibited.
            </Typography>
          </Stack>
          <DemographicsModule demographics={record.demographics} />
          <IncidentModule incident={record.incident} />
          <Safeguarding safeguarding={record.safeguarding} />
          <HSIncidentModule incident={record.incident} />
          <HxModule pmhx={record.pmhx} hx={record.history} />
          <AssessModule assess={record.assess} />
          <VitalsModule
            vitals={record.vitals?.obs}
            spo2Scale2={record.pmhx?.spo2Scale2}
            demographics={record.demographics}
          />
          <TreatmentModule treatment={record.treatment} />
          <LiveTimelineModule record={record} />
          <Plan plan={record.plan} />
          <ClinicalAdviceLine
            originalNotes={record?.clinicalAdviceLineNotes ?? []}
            epcrID={epcrID}
            calNotes={calNotes}
            setCALNotes={setCalNotes}
            currentTreatmentLocation={record?.review?.currentTreatmentLocation}
          />
          <ShareCode
            ePCRID={epcrID}
            currentTreatmentLocation={record?.review?.currentTreatmentLocation}
          />
          <Button variant="contained" onClick={() => onClose()} color="error">
            Close
          </Button>
        </Stack>
      ) : (
        <Alert severity="error">Unable to load Record</Alert>
      )}
    </BigModal>
  )
}

export default RecentPopup
